import store from '../store'
import axios from "axios";

export function authHeader() {
	const vuex = store

	// return authorization header with jwt token
	let user =  localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
	let token = localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null

	vuex.commit('auth/setToken', token)
	vuex.commit('auth/setUser', user)
		
	axios.defaults.headers.common['AppKey'] = 'SA&A-a$e25y6$e100a$8x2Ra85EdL744qaidu3s6q0ldF5R818q8Ncd6ocvb2d.9';

	if (user && token) {
		axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

		return true;
	} else {
		return false;
	}
}
